import React, { useState } from "react";

const PaymentList = ({ payments, onEdit, onDelete, isLoading }) => {
  const [editId, setEditId] = useState(null);
  const [editAmount, setEditAmount] = useState('');
  const [editDate, setEditDate] = useState('');

  if (isLoading) return <div className="text-gray-500 text-sm">Loading payments...</div>;
  if (!payments || payments.length === 0) return <div className="text-gray-400 text-sm">No payments recorded yet.</div>;

  return (
    <ul className="divide-y divide-gray-200">
      {payments.map(payment => (
        <li key={payment._id} className="flex items-center justify-between py-2">
          {editId === payment._id ? (
            <form
              className="flex gap-2 items-center w-full"
              onSubmit={e => {
                e.preventDefault();
                onEdit(payment._id, editAmount, editDate);
                setEditId(null);
              }}
            >
              <input
                type="number"
                value={editAmount}
                onChange={e => setEditAmount(e.target.value)}
                className="w-24 px-2 py-1 border rounded"
                required
                min="0"
                step="0.01"
              />
              <input
                type="date"
                value={editDate}
                onChange={e => setEditDate(e.target.value)}
                className="px-2 py-1 border rounded"
                required
              />
              <button type="submit" className="text-green-600 font-semibold">Save</button>
              <button type="button" className="text-gray-500 ml-2" onClick={() => setEditId(null)}>Cancel</button>
            </form>
          ) : (
            <>
              <span>
                <span className="font-medium">{payment.amount}</span>
                <span className="ml-2 text-gray-500 text-xs">{new Date(payment.date).toLocaleDateString()}</span>
              </span>
              <span className="flex gap-2">
                <button
                  className="text-blue-600 text-xs"
                  onClick={() => {
                    setEditId(payment._id);
                    setEditAmount(payment.amount);
                    setEditDate(payment.date.split('T')[0]);
                  }}
                >
                  Edit
                </button>
                <button
                  className="text-red-600 text-xs"
                  onClick={() => onDelete(payment._id)}
                >
                  Delete
                </button>
              </span>
            </>
          )}
        </li>
      ))}
    </ul>
  );
};

export default PaymentList;